import { useState } from "react";
import { Drawer, Image, Typography } from "antd";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import customerIcon from "../../../pics/customerServiceIcon.jpg";

const { Paragraph } = Typography;
function SignUpModal({ openAuth, setOpenAuth }) {
  const [loginPage, setLoginPage] = useState(true);
  return (
    <Drawer open={openAuth} onClose={() => setOpenAuth(false)}>
      <Paragraph
        style={{ textAlign: "center", margin: "1rem 0 2rem 0", color: "#888" }}
      >
        <Image
          src={customerIcon}
          alt="customer-icon"
          width={100}
          preview={false}
        />
        <br />
        Team up with my clients, thank you!
      </Paragraph>

      {loginPage ? (
        <LoginForm setLoginPage={setLoginPage} setOpenAuth={setOpenAuth} />
      ) : (
        <RegisterForm setLoginPage={setLoginPage} />
      )}
    </Drawer>
  );
}

export default SignUpModal;
